import { useState } from "react";

const useModalState = () => {
  const [showState, setShowState] = useState<boolean>(false);
  const [emitState, setEmitState] = useState<any>({});

  const show = () => {
    setShowState(!showState);
  };

  const emit = (payload: any) => {
    setEmitState({ ...payload });
  };

  return { show, emit, showState, emitState };
};

export default useModalState;
